import { CommonModule, NgClass } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterModule } from '@angular/router';

import * as fromRoot from '@core/redux';
import * as AuthActions from '@core/redux/auth/auth.actions';
import { select, Store } from '@ngrx/store';

declare let gapi: any;

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.less'],
  imports: [NgClass, RouterModule, ReactiveFormsModule, CommonModule],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SignInComponent implements OnInit, OnDestroy, AfterViewInit {
  private store = inject<Store<fromRoot.State>>(Store);
  private zone = inject(NgZone);

  private readonly formBuilder: FormBuilder = inject(FormBuilder);
  private destroyRef = inject(DestroyRef);
  form: FormGroup;
  validateErrors: any = {};
  isSending = false;
  googleAuth: any;

  constructor() {
    this.store.pipe(select(fromRoot.getAuthErrors), takeUntilDestroyed(this.destroyRef)).subscribe(errors => {
      this.validateErrors = errors;
    });

    this.store.pipe(select(fromRoot.getLoading), takeUntilDestroyed(this.destroyRef)).subscribe(isSending => {
      this.isSending = isSending;
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: [null, Validators.compose([Validators.required, Validators.email])],
      password: [null, [Validators.required]],
    });
  }

  ngAfterViewInit() {
    this.zone.run(() => {
      gapi.load('auth2', () => {
        this.googleAuth = gapi.auth2.init({
          clientId: '1049746922847-fk4hg4fb1787947gjnkcaadd7nn4p4gd.apps.googleusercontent.com',
          scope: 'email profile',
        });
      });
    });
  }

  ngOnDestroy() {}

  onGoogleAuth() {
    this.googleAuth.grantOfflineAccess().then(result => this._signInSuccessHandler(result));
  }

  onSubmit() {
    this.store.dispatch(new AuthActions.SignInAction(this.form.getRawValue()));
  }

  isFieldValid(field: string) {
    return !this.form.get(field).valid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'input_theme-1_error': this.isFieldValid(field),
    };
  }

  private _signInSuccessHandler(result: { code }) {
    this.zone.run(() => {
      this.store.dispatch(new AuthActions.SignUpGoogleAction(result));
    });
  }
}
